<!--suppress HtmlDeprecatedAttribute -->
<div id="reportContainer" style="width: auto"
  [hidden]="!report.isLoaded || classroom.selectedBoardTab !== ViewportTab.REPORT">
  <iframe class="homework-frame" id="reportFrame" *ngIf="report.isLoaded"
    frameborder="0" scrolling="0"
    (load)="reportLoadedHandler()"
    [src]="safeURL">
  </iframe>
</div>
